export default __webpack_public_path__ + "static/media/Epistoliki_epikoinwnia.bf3ffd5d.jpg";